import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Typography,
  GridContainer,
  Row,
  Column,
  Link,
  FlexBox,
} from "@vp/swan";
import l10n from "../localization/localization";
import styles from "../styles/cookie-message-style.scss";
import getUrl from "./get-url";

export default function BannerVariationUk(props) {
  const { onAcceptAll, onAcceptNecessary, onChangePreferences } = props;
  return (
    <GridContainer
      className={`${styles.cookieBannerUk} grid-container-proportional consent-manager-banner`}
      backgroundColor="standard"
      aria-labelledby="cookie-dialog-title"
      role="dialog"
      aria-describedby="cookie-dialog-description"
    >
      <Row marginBottom="5" paddingX={0}>
        <Column span={12} spanXs={12} paddingX={0}>
          <Typography fontSkin="title-section" id="cookie-dialog-title">
            {getBannerContentTitle()}
          </Typography>
        </Column>
      </Row>
      <Row>
        <Column span={12} paddingX={0}>
          <Typography fontSkin="body-standard" id="cookie-dialog-description">
            {getBannerContentPart(0)}
            <Link href={getPolicyLink()}>
              {l10n.t("bannerV5.policyLinkText")}
            </Link>
            {getBannerContentPart(1)}
          </Typography>
        </Column>
      </Row>
      <Row marginX={0} paddingX={0} paddingTop={6}>
        <Column span={9} spanSm={12} spanXs={12}>
          <Row>
            <Column span={12} paddingX={0}>
              <FlexBox gap={3} className={styles.actionButtonsUk}>
                <Button
                  width="full-width"
                  skin="primary"
                  title={l10n.t("bannerV5.accept")}
                  aria-label={l10n.t("bannerV5.accept")}
                  onClick={onAcceptAll}
                >
                  {l10n.t("bannerV5.accept")}
                </Button>
                <Button
                  width="full-width"
                  skin="primary"
                  title={l10n.t("bannerV5.rejectNonEssential")}
                  aria-label={l10n.t("bannerV5.rejectNonEssential")}
                  onClick={onAcceptNecessary}
                >
                  {l10n.t("bannerV5.rejectNonEssential")}
                </Button>
              </FlexBox>
            </Column>
          </Row>
        </Column>
        <Column
          span={3}
          spanSm={12}
          spanXs={12}
          className={styles.settingsLinkCol}
        >
          <Link
            textAlign="center"
            title={l10n.t("bannerV5.settings")}
            aria-label={l10n.t("bannerV5.settings")}
            render={(p) => (
              <Button
                skin="link"
                className={p.className}
                onClick={onChangePreferences}
              >
                {p.children}
              </Button>
            )}
          >
            {l10n.t("bannerV5.settings")}
          </Link>
        </Column>
      </Row>
    </GridContainer>
  );
}

function getPolicyLink() {
  return getUrl(l10n.tUrl("privacyAndCookiePolicy"));
}

function getBannerContentPart(part) {
  const policyText = l10n.t("bannerV5.content").split("#policy-link#");
  if (policyText.length > part) {
    return policyText[part];
  }

  return "";
}

function getBannerContentTitle() {
  const policyText = l10n.t("bannerV5.title").replace("#break#", " ");
  return policyText;
}

BannerVariationUk.displayName = "Banner";

BannerVariationUk.propTypes = {
  onAcceptAll: PropTypes.func.isRequired,
  onAcceptNecessary: PropTypes.func.isRequired,
  onChangePreferences: PropTypes.func.isRequired,
};
